import React, { useState } from 'react';
import quizData from '../quizData';

function Welcome({ onStartQuiz }) {
  const [nickname, setNickname] = useState('');
  const [grade, setGrade] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (nickname.trim() && grade.trim()) {
      onStartQuiz(nickname, grade);
    } else {
      alert('Proszę podać pseudonim i zespół.');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-white text-gray-800">
      <div className="bg-white shadow-xl rounded-xl p-8 max-w-2xl w-full border border-gray-200">
        <h1 className="text-4xl font-bold mb-6 text-digital-orange text-center filter drop-shadow-sm">{quizData.title}</h1>
        <p className="mb-8 text-lg text-gray-700 whitespace-pre-line text-center">
          {quizData.introduction}
        </p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="nickname" className="block text-sm font-medium text-gray-700 mb-1">Pseudonim:</label>
            <input
              type="text"
              id="nickname"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-digital-orange focus:border-digital-orange sm:text-sm text-gray-800"
              placeholder="Twój pseudonim"
            />
          </div>
          <div>
            <label htmlFor="grade" className="block text-sm font-medium text-gray-700 mb-1">Zespół:</label>
            <input
              type="text"
              id="grade"
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
              className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-digital-orange focus:border-digital-orange sm:text-sm text-gray-800"
              placeholder="Np. Marketing / Sprzedaż"
            />
          </div>
          <button
            type="submit"
            className="w-full btn btn-primary text-lg py-3 shadow-lg transform hover:scale-105 transition duration-150"
          >
            Rozpocznij Quiz
          </button>
        </form>
      </div>
    </div>
  );
}

export default Welcome; 